import * as yup from 'yup';

import { Incident } from '../../core/api/clients';

type IncidentData = Pick<Incident, 'riskRating' | 'severityCategory'>;

const IncidentValidationSchema: yup.ObjectSchema<IncidentData> = yup.object({
  riskRating: yup.string()
    .nullable()
    .label('riskRating')
    .required()
    .meta({ step: 1 }),
  severityCategory: yup.string()
    .nullable()
    .label('severityCategory')
    .required()
    .meta({ step: 1 }),
});

export default IncidentValidationSchema;
